export default __webpack_public_path__ + "static/media/slide1.fb34be0c.png";